export default "__VITE_ASSET__BwToKV68__"